export default __webpack_public_path__ + "static/media/IVHP.83331211.jpg";